export default {
  PhotoReview: {
    queued: { Text: 'In attesa di revisione' },
    reviewed: { Text: 'Revisionato' },
  },
  PhotoRating: {
    pending: {
      Text: 'In attesa di revisione',
      Description:
        'Disponibile per la maggior parte degli utenti (chi ha disattivato la Navigazione sicura)',
    },
    public: {
      Text: 'Pubblico',
      Description: 'Disponibile per tutti',
    },
    'public-sensitive': {
      Text: 'Pubblico',
      Description:
        'Disponibile per la maggior parte degli utenti (chi ha disattivato la Navigazione sicura)',
    },
    banned: {
      Text: 'Contenuto vietato',
      Description: "Contrassegnato per l'eliminazione",
    },
    private: {
      Text: 'Privato',
      Description: 'Disponibile solo per gli utenti autorizzati da te',
    },
    message: {
      Text: 'Elemento del messaggio',
      Description: 'Solo per il destinatario',
    },
    other: {
      Text: 'Sconosciuto',
      Description: '',
    },
  },
  Community: {
    default: {
      TextField1: 'Occupazione',
      TextField2: 'Istruzione',
      TextField3: 'Interessi',
    },
    ferzu: {
      TextField1: 'La mia Fursona',
      TextField2: 'Occupazione / Istruzione',
      TextField3: 'Interessi',
    },
    pupspace: {
      TextField1: 'I miei hobby',
      TextField2: 'I miei kink e la mia attrezzatura',
      TextField3: 'I miei limiti e la mia salute',
    },
  },
  CommunityCategories: {
    fandomsRoleplay: { Name: 'Fandom e gioco di ruolo' },
    plusSize: { Name: 'Taglie forti' },
    menInterestedInMen: { Name: 'Uomini interessati agli uomini' },
  },
  CommunityInfo: {
    headings: {
      about: 'Informazioni su {{communityName}}',
      whatYouCanDo: 'Cosa puoi fare su {{communityName}}',
      rules: 'Le nostre regole della community',
      welcome: 'Benvenuto su {{communityName}}',
    },
    communities: {
      grommr: {
        caption: 'Gainers & Encouragers (gay)',
        description:
          'Una community di gainer ed encourager per uomini gay e bisessuali che celebra positività corporea, crescita, inclusione e accettazione.',
        sections: {
          about:
            'Grommr è orgogliosa di servire la community dei gainer/encourager gay e bisessuali dal 2011. La community di Grommr riunisce una vasta gamma di uomini di tutto il mondo che condividono una cosa in comune: l\'idea che più grande è meglio.\n\nGrommr offre un forum inclusivo affinché la nostra community possa connettersi, legare e prosperare. Coordiniamo anche incontri locali regolari (chiamati GrommOffs) e organizziamo conferenze semestrali più grandi, come The Grom ed EuroGrom.\n\nNon siamo la prima rete a servire la community gainer‑encourager, che si connette sin dagli anni \'80. Per saperne di più sulla storia di questa fantastica community body‑positive, consulta <a href="https://www.grommr.com/Home/Community">The Gainer History Project</a>.',
          whatYouCanDo:
            ' • Sfoglia il feed, crea post, commenta e partecipa alle discussioni.\n • Esplora i profili nelle vicinanze o cerca membri con interessi simili.\n • Avvia chat con nuovi contatti o vecchi amici.\n • Condividi le tue foto o guarda le foto recenti degli altri membri.\n • Scopri gli eventi della community gainer vicino a te.',
          rules:
            'Ci impegniamo per mantenere Grommr una casa accogliente per tutti i nostri membri. Qualsiasi attività illegale, trolling, molestie, razzismo, misoginia, omofobia, transfobia, abilismo, grassofobia e manifestazioni pubbliche di nudità o atti sessuali sono severamente vietati su Grommr.',
          welcome:
            'Se il nostro team di amministrazione può aiutarti in qualcosa, non esitare ad aprire un ticket di supporto o a inviarci un\'e‑mail.\n\nBenvenuto!\n\nIl team di Grommr',
        },
      },
      feabie: {
        caption: 'Feedism & BBW',
        description:
          'Una community di feedism per tutti che celebra positività corporea, crescita, inclusione e accettazione.',
        sections: {
          about:
            'Feabie offre un ambiente inclusivo in cui i membri della community feedism — di ogni orientamento — possono connettersi, che sia per una chat, un appuntamento o un evento. Diamo il benvenuto a feedist, ammiratori dei curvy, BBW/BHM e a chiunque si senta a casa su Feabie.\n\nOltre alla nostra community online, Feabie coordina anche i FeabieMeets — una serie di incontri locali che riuniscono una grande varietà di membri Feabie per connettersi offline.\n\nFeabie è il più grande social network al servizio della community feedism e uno dei più grandi network body‑positive al mondo.',
          whatYouCanDo:
            ' • Sfoglia il feed, crea post, commenta e partecipa alle discussioni.\n • Esplora i profili nelle vicinanze o cerca membri con interessi simili.\n • Avvia una chat e organizza un appuntamento, o semplicemente risentiti con gli amici.\n • Condividi le tue foto o guarda le foto recenti degli altri membri.\n • Scopri gli eventi della community feedism vicino a te.',
          rules:
            'I nostri amministratori lavorano duramente per mantenere Feabie il più inclusiva e accogliente possibile. Attività illegali, trolling, molestie, razzismo, misoginia, omofobia, transfobia, abilismo, grassofobia e manifestazioni pubbliche di nudità o atti sessuali sono severamente vietati su Feabie.',
          welcome:
            'I nostri amministratori sono qui per aiutarti! Se hai domande o preoccupazioni, non esitare ad aprire un ticket di supporto o a inviarci un\'e‑mail.\n\nBenvenuto!\n\nIl team di Feabie',
        },
      },
      chasabl: {
        caption: 'Bears, Chubs & Chasers (gay)',
        description:
          'Una community chub‑bear per uomini gay e bisessuali che celebra positività corporea, inclusione e accettazione.',
        sections: {
          about:
            'Chasable è orgogliosa di essere, dal 2013, il più grande social network per la community chub‑bear. Da allora, Chasable si è guadagnata la reputazione di ambiente accogliente per uomini gay e bisessuali di tutte le taglie, forme e colori. Diamo il benvenuto a chubs, bears, chasers e a chiunque si riconosca.\n\nAnche se la community chub‑bear è servita da diverse app di incontri, nessuna app offre le funzionalità sociali di Chasable. Il feed di Chasable è un punto vitale di discussione, condivisione di foto e supporto per la community.\n\nChasable supporta regolarmente grandi eventi chub‑bear, come Tidal Wave a Orlando e le serate BGMO a New York, e aiuta a promuovere eventi chub‑bear in tutto il mondo.',
          whatYouCanDo:
            ' • Esplora ragazzi nelle vicinanze o cerca chubs, bears e chasers con interessi simili.\n • Condividi le tue foto o guarda le foto recenti degli altri membri.\n • Sfoglia il feed, crea post, commenta e partecipa alle discussioni.\n • Invia un flirt, avvia una chat con un nuovo ragazzo o risentiti con gli amici.\n • Scopri eventi chub‑bear vicino a te.',
          rules:
            'Gli amministratori di Chasable aiutano a mantenere la nostra community uno spazio sicuro per tutti. Attività illegali, trolling, molestie, razzismo, misoginia, omofobia, transfobia, abilismo, grassofobia e manifestazioni pubbliche di nudità o atti sessuali sono severamente vietati su Chasable.',
          welcome:
            'Hai domande? Vedi qualcosa che non dovrebbe essere su Chasable? Il nostro team di amministrazione è qui per aiutarti! Apri un ticket di supporto in qualsiasi momento o scrivici una e‑mail.\n\nBenvenuto!\n\nIl team di Chasable',
        },
      },
      ferzu: {
        caption: 'Furries & Anthros',
        description:
          'Una community furry per tutti che celebra il fandom furry, l\'arte furry e l\'inclusione.',
        sections: {
          about:
            'Ferzu è il più grande social network dedicato al fandom furry. Che la tua fursona cammini, voli o nuoti, che tu sia etero o LGBTQ, paffuto o magro, a strisce o a macchie, troverai una casa inclusiva su Ferzu.\n\nSiamo orgogliosi di offrire uno spazio sicuro in cui tutti i furry possano connettersi e prosperare. Spesso su Ferzu avvengono discussioni che non avverrebbero mai sui social tradizionali più tolleranti verso i troll.',
          whatYouCanDo:
            ' • Sfoglia il feed, crea post, commenta e partecipa alle discussioni.\n • Guarda le ultime opere d\'arte furry e condividi le tue.\n • Esplora i profili nelle vicinanze o cerca furry con interessi simili.\n • Avvia chat con nuovi contatti o vecchi amici.\n • Scopri le convention furry, vedi chi partecipa e unisciti al divertimento.',
          rules:
            'Ferzu è uno spazio sicuro per tutti i furry. Pertanto, trolling, molestie, razzismo, misoginia, omofobia, transfobia, abilismo e manifestazioni pubbliche di nudità o atti sessuali sono severamente vietati.\n\nCi teniamo anche profondamente agli artisti che costituiscono la spina dorsale della nostra community. Per questo i nostri amministratori applicano politiche rigorose per proteggere l\'arte furry.',
          welcome:
            'Il nostro team di amministrazione è sempre disponibile per rispondere alle tue domande o aiutarti con qualsiasi problema su Ferzu. Se hai bisogno di qualcosa, non esitare ad aprire un ticket di supporto o a inviarci un\'e‑mail.\n\nUn grande benvenuto furry!\n\nIl team di Ferzu',
        },
      },
      pupspace: {
        caption: 'Cuccioli umani e handler',
        description:
          'Una nuova community di pup play per cuccioli umani, handler e chiunque ami entrare nella mentalità da cucciolo.',
        sections: {
          about:
            'Pupspace è il primo social network e app dedicati a servire la community del puppy play e i nostri amici. I membri di tutti i generi, identità e background sono i benvenuti.\n\nCi impegniamo a costruire una community inclusiva e accogliente per tutti i nostri membri, indipendentemente da come ti identifichi, dove vivi o se sei impegnato o meno. Pupspace è un luogo sicuro in cui i membri sono liberi di esplorare, essere sé stessi, entrare nella mentalità da cucciolo e liberare il proprio cucciolo interiore.',
          whatYouCanDo:
            '• Sfoglia il feed, crea post, commenta e partecipa alle discussioni con altri cuccioli e handler.\n• Esplora i profili nelle vicinanze o cerca cuccioli con interessi simili.\n• Avvia una chat, organizza un playdate o semplicemente risentiti con gli amici.\n• Condividi le tue foto o guarda le foto recenti di altri cuccioli.\n• Scopri eventi e moshes per cuccioli vicino a te.',
          rules:
            'Gli amministratori di Pupspace lavorano duramente per mantenere la nostra community il più inclusiva e accogliente possibile. Attività illegali, trolling, molestie, razzismo, misoginia, omofobia, transfobia, abilismo e manifestazioni pubbliche di nudità o atti sessuali sono severamente vietati su Pupspace.',
          welcome:
            'I nostri amministratori sono qui per aiutarti! Se hai una domanda o una preoccupazione, non esitare ad aprire un ticket di supporto o a inviarci un\'e‑mail.\n\nBenvenuto nella tua nuova casa! *wags*\n\nIl team di Pupspace',
        },
      },
    },
  },
  communities: {
    myCommunities: 'Le mie community',
  },
  PostType: {
    ChangedLocation: 'Ha cambiato la sua posizione in: {{text}}',
    ChangedNickname: 'Ha cambiato il suo nome utente: {{text}}',
    ChangedRelStatus: 'Ha cambiato il suo stato di relazione',
    ChangedWeight: 'Ha cambiato il suo peso a {{newWeight}}, un aumento di {{newWeightDiff}}',
    NewMember: 'Si è unito a {{communityName}}',
    NewPhoto: 'Ha pubblicato una nuova foto',
    NewEvent: 'Ha pubblicato un nuovo evento: ',
    NotifyNewComment: {
      post: 'ha commentato un post',
      photo: 'ha commentato una foto',
    },
    NotifyNewFollow: 'ha iniziato a seguirti',
    NotifyNewWallToWall: 'ha pubblicato sulla tua bacheca',
    NotifyPhotoLike: 'ha messo mi piace alla tua foto',
    NotifyUnlocked: "ti ha concesso l'accesso alle sue foto private",
    NotifyUnlockRequest: "sta richiedendo l'accesso alle tue foto private",
  },
  TransactionType: {
    Admin: 'Pass {{premium}} admin',
    Adjustment: 'Aggiustamento',
    BOGO: 'Promozione {{premium}} (compra uno, prendi uno gratis)',
    Courtesy: 'Pass {{premium}} di cortesia',
    DonationWithPaypal: 'Donazione, grazie! (pagato con PayPal)',
    FoundingMember: 'Pass {{premium}} membro fondatore',
    GiftCertificatePaidFor: 'Acquisto certificato regalo {{premium}}',
    GiftCertificateRedeemed: 'Certificato regalo {{premium}} riscattato',
    PaidByMail: 'Acquisto pass {{premium}} (pagato con contanti/assegno/vaglia postale)',
    PaidWithApple: 'Abbonamento {{premium}} (pagato con Apple App Store)',
    PaidWithCCBill: 'Abbonamento {{premium}} (pagato con CCBill)',
    PaidWithGoogle: 'Abbonamento {{premium}} (pagato con Google Play)',
    PaidWithPaypal: 'Acquisto pass {{premium}} (pagato con PayPal)',
    PaidWithStripe: 'Abbonamento {{premium}} (pagato con Stripe)',
    Referrals: 'Tempo {{premium}} guadagnato da referral',
    Refund: 'Credito/Rimborso',
    Trial: 'Prova gratuita {{premium}}',
  },

  ProfileTags: {
    BodyFeatures: {
      Armpits: 'Ascelle',
      ArmsLegs: 'Braccia/gambe',
      Asses: 'Culi',
      Athletic: 'Atletico',
      Average: 'Medio',
      Balbo: 'Balbo',
      BallBelly: 'Pancia a palla',
      Beard: 'Barba',
      Beards: 'Barbe',
      Bellies: 'Pance',
      BellyButtons: 'Ombelichi',
      BodyMods: 'Modificazione corporea',
      Breasts: 'Seni (femminili)',
      BreastsFemale: 'Seni (femminili)',
      BreastsMale: 'Seni (maschili)',
      ChestPecs: 'Petto/pettorali',
      ChinStrap: 'Sottogola',
      Chubby: 'Paffuto ovunque',
      Chubby2: 'Paffuto',
      ChubbyBelly: 'Paffuto con pancia',
      ChunkyMuscle: 'Muscolo spesso',
      Curvy: 'Sinuoso',
      Feet: 'Piedi',
      First30: 'Prime 30 libbre',
      FullBeard: 'Barba piena',
      Goatee: 'Pizzetto',
      Hairy: 'Peloso',
      Hands: 'Mani',
      Husky: 'Robusto',
      LightBeard: 'Barba leggera',
      LoveHandles: "Maniglie dell'amore",
      ManTits: 'Tette maschili',
      Moustache: 'Baffi',
      MuscleGut: 'Muscolo e pancia',
      Muscular: 'Muscolare',
      MuttonChops: 'Basette',
      Nipples: 'Capezzoli',
      None: 'Nessuna',
      PearChubby: 'Paffuto a pera',
      PencilThin: 'Linea sottile',
      Piercings: 'Piercing',
      SlightlyChubby: 'Leggermente paffuto',
      Slim: 'Snello',
      Smooth: 'Liscio',
      SomeHair: 'Qualche pelo',
      SuperChub: 'Super paffuto',
      SuperChubby: 'Super paffuto',
      Tattoos2: 'Tatuaggi',
      ThickCurvy: 'Spesso/sinuoso',
      Thin: 'Magro',
      Toned: 'Muscolo tonico',
      Trimmed: 'Accorciato',
      VanDyke: 'Van Dyke',
      VeryChubby: 'Molto paffuto',
      VeryHairy: 'Molto peloso',
    },
    Other: {
      AfterCare: 'Cure post',
      Agender: 'Agender',
      AgePlay: 'Gioco di età',
      AnalPlayBottom: 'Anale (passivo)',
      AnalPlayTop: 'Anale (attivo)',
      Androgynous: 'Androgino',
      Asexuality: 'Asessualità',
      Babyfur: 'DiaperFur',
      BalloonPlay: 'Gioco con palloncini',
      Bathing: 'Bagno/Doccia',
      BDSM: 'BDSM',
      Belching: 'Rutti',
      BellyPlay: 'Gioco della pancia',
      BellyRubs: 'Sfregamenti della pancia',
      Biting: 'Mordere',
      BitsGags: 'Morsi/Bavagli',
      Bloating: 'Bloating',
      Blueberry: 'Mirtillo',
      BodyOdors: 'Profumo/Odore corporeo',
      Bodypaint: 'Pittura corporea',
      BodyWorship: 'Adorazione del corpo',
      Bondage: 'Bondage/dominazione',
      Bondage2: 'Bondage',
      Boots: 'Stivali',
      BootsHeels: 'Stivali e tacchi alti',
      BootsWorship: 'Adorazione degli stivali',
      BowlEating: 'Mangiare dalla ciotola',
      Brats: 'Viziati',
      BreastGrowth: 'Crescita del seno',
      BreathPlay: 'Gioco del respiro',
      Burping: 'Rutti',
      Businessmen: "Uomini d'affari",
      ButtplugsDildos: 'Plug anali/Dildo',
      CageSleep: 'Dormire in gabbia',
      CBT: 'CBT',
      Chastity: 'Castità',
      Cigars: 'Sigari/pipe/tabacco',
      CollaredOwned: 'Con collare/Posseduto',
      Complicated: 'È complicato',
      Control: 'Controllo',
      CrossDress: 'Travestimento',
      Cuckolding: 'Cornificare',
      Cuddling: 'Coccole/frottage',
      CunnGiver: 'Cunnilingus (dare)',
      CunnReceiver: 'Cunnilingus (ricevere)',
      DaddySon: 'Gioco di ruolo papà-figlio',
      Dating: 'Appuntamenti',
      DatingBreak: 'Prendendosi una pausa dagli appuntamenti',
      Diapers: 'AB/DL',
      DirtyFur: 'Dirtyfur',
      DirtyTalking: 'Parlare sporco',
      Discipline: 'Disciplina/Punizioni',
      DoctorPatient: 'Gioco di ruolo dottore-paziente',
      Dogshow: 'Esposizione canina',
      Domination: 'Dominazione',
      DomSub: 'Dominazione/sottomissione',
      EdgePlay: 'Gioco estremo',
      EdgingOrgasm: "Controllo dell'orgasmo/edging",
      Engaged: 'Fidanzato',
      EStim: 'Elettrostimolazione',
      Exhibitionism: 'Esibizionismo/Sesso pubblico',
      ExplodBellies: 'Pance che esplodono',
      FaceSitting: 'Sedersi sulla faccia',
      Farting: 'Scoregge',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FeedingFeedee: 'Feeding (ricevere)',
      FeedingFeeder: 'Feeding (dare)',
      Female: 'Donna',
      Feminine: 'Femminile',
      Fighting: 'Lotta/Combattimento',
      Fingering: 'Stimolazione digitale',
      Fisting: 'Fisting',
      FistingBottom: 'Fisting (passivo)',
      FistingTop: 'Fisting (attivo)',
      Flogging: 'Flagellazione/Fruste',
      FootWorship: 'Adorazione dei piedi',
      ForceFeeding: 'Feeding forzata',
      Furries: 'Furries',
      Fursuit: 'Fursuit',
      Gaining: 'Aumentare di peso/incoraggiare',
      GainingInstant: 'Aumento istantaneo',
      GainingLT: 'Aumento a lungo termine',
      Gassy: 'Gassoso',
      Genderfluid: 'Genere fluido',
      GenderNonconforming: 'Non conforme al genere',
      GenderShifting: 'Cambio di genere',
      GroupSex: 'Sesso di gruppo',
      GrowUnhealthy: 'Crescita malsana',
      Gunge: 'Fango',
      GutPunch: 'Pugni alla pancia',
      HandJob: 'Masturbazione',
      HandlerTrainer: 'Addestratore/Gestore',
      HandsfreeOrgasm: 'Orgasmo senza mani',
      HeatEstrus: 'Calore/Estro',
      Heels: 'Tacchi',
      Humiliation: 'Umiliazione',
      Hypnosis: 'Ipnosi',
      Hypnotization: 'Ipnosi',
      Immobility: "Guadagnare fino all'immobilità",
      Inflation: 'Inflazione',
      Intersex: 'Intersessuale',
      InTraining: 'In addestramento',
      KennelSleep: 'Dormire in un cesto/canile',
      Kissing: 'Baciare',
      KnotPlay: 'Gioco di nodi/legare',
      Latex: 'Lattice',
      LeashWalk: 'Camminare al guinzaglio',
      Leather: 'Pelle',
      Licking: 'Leccare',
      Lipstick: 'Unghie e rossetto',
      Lycantropy: 'Licantropia',
      Lycra: 'Lycra',
      MacroMicro: 'Fantasie macro/micro',
      Male: 'Uomo',
      MalePreg: 'Mpreg (gravidanza maschile)',
      ManScent: 'Odore maschile/corporeo',
      Married: 'Sposato',
      Masculine: 'Maschile',
      Masochism: 'Masochismo',
      Mature: 'Partner maturi/anziani',
      Measuring: 'Misurare/pesare',
      Men: 'Uomini',
      MessyEat: 'Mangiare disordinatamente',
      MessyEating: 'Mangiare disordinato/gioco del maiale',
      MicroPenis: 'Micropene',
      Military: 'Militare',
      Monogamous: 'Monogamo',
      MpregBirthing: 'Mpreg/parto',
      Murrsuit: 'Murrsuit',
      MuscleGrow: 'Crescita muscolare',
      MuscleWorship: 'Adorazione muscolare',
      Musk: 'Muschio',
      MutualMasturb: 'Masturbazione reciproca',
      Muzzles: 'Museruole',
      Neoprene: 'Neoprene',
      NipplePlay: 'Gioco dei capezzoli',
      NonBinary: 'Non binario',
      NonSexPupPlay: 'Gioco del pup non sessuale',
      Obedience: "Addestramento all'obbedienza/comandi",
      OlderMen: 'Uomini maturi/anziani',
      OpenPolyRelation: 'In una relazione poli aperta',
      OpenRelationship: 'In una relazione aperta',
      OralBottom: 'Orale (passivo)',
      OralPlayBottom: 'Orale (dare)',
      OralPlayTop: 'Orale (ricevere)',
      OralTop: 'Orale (attivo)',
      Other: 'Altro',
      Oviposition: 'Ovideposizione',
      Owner: 'Proprietario',
      Pack: 'In un branco',
      Padding: 'Imbottitura',
      Pegging: 'Pegging',
      Petting: 'Grattare/accarezzare',
      PigPlay: 'Gioco del maiale',
      PissPlay: 'Giochi di urina/sport acquatici',
      Plugtail: 'Coda con plug',
      Plush: 'Peluche',
      Polyamorous: 'Poliamoroso',
      PolyRelation: 'In una relazione poli',
      Pregnancy: 'Gravidanza',
      Primal: 'Primitivo',
      PublicSex: 'Sesso pubblico/voyeurismo',
      Punks: 'Punk',
      PupGear: 'Attrezzatura da pup',
      PupPlay: 'Gioco del pup',
      PuppyGames: 'Giochi del pup (riporto, piscina di palline)',
      PuppyToys: 'Giocattoli del pup',
      Queer: 'Queer',
      Relationship: 'In una relazione',
      Rimming: 'Rimming',
      RimmingGiver: 'Rimming (dare)',
      RimmingReceiver: 'Rimming (ricevere)',
      RolePlay: 'Gioco di ruolo',
      Rubber: 'Gomma',
      RubberLatexLeather: 'Gomma/lattice/pelle',
      Sadism: 'Sadismo',
      SadoMaso: 'Sadomasochismo',
      Saline: 'Salino',
      Scat: 'Scat',
      SciFiGain: 'Aumento fantascientifico',
      Scratching: 'Grattare',
      SensoryDep: 'Privazione sensoriale',
      SexualCanineRole: 'Ruolo canino sessuale',
      SheathPlay: 'Gioco del prepuzio',
      Single: 'Single',
      Skinheads: 'Skinhead',
      Smashing: 'Schiacciare/frantumare',
      SmashingSitting: 'Schiacciare/sedersi su qualcuno',
      Sniffing: 'Annusare',
      Sounding: 'Sounding/cateteri',
      Spanking: 'Sculacciate',
      SpeciesSpecific: 'Specifico della specie',
      Speedos: 'Speedos/lycra',
      Sportswear: 'Abbigliamento sportivo',
      Squashing: 'Schiacciamento',
      StraightMen: 'Uomini etero/sposati',
      Stray: 'Randagio',
      StretchMarks: 'Smagliature',
      Stuffing: 'Riempimento',
      Submission: 'Sottomissione',
      Suits: 'Completi',
      Swinging: 'Scambio e sesso di gruppo',
      TailPulling: 'Tirare la coda',
      Tattoos: 'Tatuaggi/piercing',
      Teasing: 'Stuzzicare',
      TeasingPublic: 'Stuzzicare/umiliazione pubblica',
      Technophilia: 'Tecnofilia',
      Tentacles: 'Tentacoli',
      Tickling: 'Solletico',
      TightClothes: 'Vestiti stretti/bottoni che scoppiano',
      Toons: 'Toons',
      Toys: 'Giocattoli/dildo',
      Trans: 'Transessuali/intersessuali',
      Transformation: 'Trasformazione',
      Transgender: 'Transgender',
      TransMan: 'Uomo trans',
      TransMen: 'Uomini trans',
      TransWoman: 'Donna trans',
      TransWomen: 'Donne trans',
      Treats: 'Dolcetti/ricompense',
      TwoSpirit: 'Due spiriti',
      Uncle: 'Fantasie zio/padre/cugino',
      UncollaredUnowned: 'Senza collare/senza proprietario',
      UnderConsideration: 'In considerazione',
      Underwear: 'Biancheria intima',
      Uniforms: 'Uniformi',
      VacantKennel: 'Canile vacante',
      VacBed: 'Letto a vuoto/sacchi a pelo',
      Vanilla: 'Vaniglia/coccole',
      VetRoleplay: 'Gioco di ruolo veterinario-animale',
      Vore: 'Vore',
      VoyeurExhib: 'Voyeurismo ed esibizionismo',
      Voyeurism: 'Voyeurismo',
      WaterSports: 'Sport acquatici',
      WaxPlay: 'Gioco con cera',
      WeightGain: 'Aumento di peso',
      Wet: 'Look bagnato/jeans bagnati',
      Widowed: 'Vedovo',
      Women: 'Donne',
      Wrestling: 'Lotta/body',
    },
    SocialTags: {
      Admirer: 'Admirer',
      Alpha: 'Alfa',
      Amphibian: 'Anfibio',
      Aquatic: 'Acquatico',
      Avian: 'Aviario',
      BBW: 'Big Beautiful Woman',
      Bear: 'Orso',
      BearSpecie: 'Orso',
      Beta: 'Beta',
      BHM: "Big Handsome Man",
      Bloater: 'Bloater',
      Bovid: 'Bovino',
      Boy: 'Ragazzo',
      Bull: 'Toro',
      Canid: 'Canide',
      Cervid: 'Cervide',
      CatKitten: 'Gatto/Gattino',
      Chaser: 'Chaser',
      Chub: 'Chub',
      Chub4Chub: 'Chub4Chub',
      ChubbyBear: 'Orso Paffuto',
      Cub: 'Cub',
      Daddy: 'Papà',
      Dog: 'Cane',
      Dominant: 'Dom',
      Dragon: 'Drago',
      Encourager: 'Encourager',
      Exotic: 'Esotico',
      FA: 'Fat Admirer',
      Feedee: 'Feedee',
      Feeder: 'Feeder',
      FelineLarge: 'Felino (grande)',
      FelineSmall: 'Felino (piccolo)',
      Fox: 'Volpe',
      FriendOfPups: 'Amico dei pups',
      Gainer: 'Gainer',
      HandlerTrainer: 'Addestratore/Gestore',
      Horse: 'Cavallo',
      HorsePony: 'Cavallo/Pony',
      Hybrid: 'Ibrido',
      Maintainer: 'Maintainer',
      Marsupial: 'Marsupiale',
      Master: 'Padrone',
      Mistress: 'Padrona',
      Mommy: 'Mamma',
      MuscleGainer: 'Gainer Muscolare',
      Omega: 'Omega',
      Otter: 'Lontra',
      OtherMammal: 'Altro (mammifero)',
      OtherSpecie: 'Altro',
      Panda: 'Panda',
      PetOther: 'Animale (altro)',
      Primate: 'Primate',
      Pup: 'Pup',
      Rabbit: 'Coniglio',
      Raccoon: 'Procione',
      Reptilian: 'Rettile',
      Rodent: 'Roditore',
      Sir: 'Signore',
      Skunk: 'Puzzola',
      Slave: 'Schiavo',
      Submissive: 'Sub',
      Switch: 'Switch',
      Wolf: 'Lupo',
    },
    Languages: {
      Arabic: 'Arabo',
      Bulgarian: 'Bulgaro',
      Chinese: 'Cinese',
      Czech: 'Ceco',
      Danish: 'Danese',
      Dutch: 'Olandese',
      English: 'Inglese',
      Filipino: 'Filipino',
      Finnish: 'Finlandese',
      French: 'Francese',
      German: 'Tedesco',
      Greek: 'Greco',
      Hebrew: 'Ebraico',
      Hindi: 'Hindi',
      Hungarian: 'Ungherese',
      Indonesian: 'Indonesiano',
      Italian: 'Italiano',
      Japanese: 'Giapponese',
      Korean: 'Coreano',
      Norwegian: 'Norvegese',
      Others: 'Altro/i',
      Persian: 'Persiano',
      Polish: 'Polacco',
      Portuguese: 'Portoghese',
      Romanian: 'Rumeno',
      Russian: 'Russo',
      SerboCroatian: 'Serbo-croato',
      Sign: 'Linguaggio dei segni',
      Slovak: 'Slovacco',
      Spanish: 'Spagnolo',
      Swedish: 'Svedese',
      Thai: 'Tailandese',
      Turkish: 'Turco',
      Ukranian: 'Ucraino',
      Urdu: 'Urdu',
      Vietnamese: 'Vietnamita',
    },
    Interests: {
      AddPackMembers: 'Espandere il mio branco',
      Alpha: 'Alfa',
      AsexualRelationship: 'Relazione asessuale',
      BdsmDynamic: 'Dinamica BDSM',
      Beta: 'Beta',
      Boy: 'Ragazzo',
      Collaring: 'Collare',
      Daddy: 'Papà',
      Date: 'Appuntamento',
      Dominant: 'Dom',
      Exploration: 'Iniziazione/Esplorazione',
      FormPack: 'Formare un nuovo branco',
      Friends: 'Amici',
      Gaming: 'Giochi',
      HandlerTrainer: 'Addestratore/Gestore',
      Hookup: 'Incontro occasionale',
      JoinPack: 'Unirsi a un branco esistente',
      Master: 'Padrone',
      Mistress: 'Padrona',
      Mommy: 'Mamma',
      Moshes: 'Moshes/eventi pup',
      NonSexualPlaymates: 'Compagni di gioco non sessuali',
      Omega: 'Omega',
      OnlineChat: 'Chat online',
      OnlineVideo: 'Video online (cam2cam)',
      PolyRelation: 'Relazione poli',
      PolyRelationship: 'Relazione poli',
      Relationship: 'Relazione',
      RoleplayPartner: 'Partner di gioco di ruolo',
      RomanticPartner: 'Partner romantico',
      Sex: 'Incontro occasionale',
      SexPartner: 'Partner intimo regolare',
      Sir: 'Signore',
      Slave: 'Schiavo',
      Submissive: 'Sub',
      Switch: 'Switch',
      Training: 'Addestramento',
      VideoChat: 'Video chat',
    },
    Ethnicities: {
      Arab: 'Medio Oriente/nord Africa',
      Asian: 'Asiatico orientale',
      Black: 'Nero/discendenza africana',
      Hispanic: 'Ispanico/Latinx',
      Mixed: 'Misto/multi',
      Native: 'Nativo americano/indigeno',
      Pacific: 'Isole del Pacifico',
      SouthAsian: 'Asiatico del sud',
      White: 'Bianco/caucasico',
    },
  },
};
